import { lazy } from "react";

const PagesRoutes = [
  {
    path: "/pages/blank-page",
    component: lazy(() => import("../../view/pages/blank")),
    layout: "VerticalLayout",
  },
  {
    path: "/pages/error-page",
    component: lazy(() => import("../../view/pages/error")),
    layout: "FullLayout",
  },
  {
    path: "/login",
    component: lazy(() => import("../../view/Login/index")),
    layout: "FullLayout",
  },
  {
    path: "/dashboard",
    component: lazy(() => import("../../view/Dashboard")),
    layout: "VerticalLayout",
  },
  {
    path: "/salesquotation",
    component: lazy(() => import("../../view/SalesQuote/SalesQuoteList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newsalesquotation",
    component: lazy(() => import("../../view/SalesQuote/AddorUpdateSalesQuote/index")),
    layout: "VerticalLayout",
  },
  {
    path: "/salesorder",
    component: lazy(() => import("../../view/SalesOrder/SalesOrderList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newsalesorder",
    component: lazy(() => import("../../view/SalesOrder/AddorupdateSalesOrder")),
    layout: "VerticalLayout",
  },
  {
    path: "/flexiquote",
    component: lazy(() => import("../../view/FlexiQuote/FlexiQuoteList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newflexiquote",
    component: lazy(() => import("../../view/FlexiQuote/AddorUpdateFlexiQuote")),
    layout: "VerticalLayout",
  },
  {
    path: "/invoice",
    component: lazy(() => import("../../view/Invoice")),
    layout: "VerticalLayout",
  },
  {
    path: "/notification",
    component: lazy(() => import("../../view/Notifications")),
    layout: "VerticalLayout",
  },
  {
    path: "/approvals",
    component: lazy(() => import("../../view/Approvals")),
    layout: "VerticalLayout",
  },
  {
    path: "/crm/enquiry",
    component: lazy(() => import("../../view/Enquiry/enquiryList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newenquiry",
    component: lazy(() => import("../../view/Enquiry/enquiryAddAndUpdate")),
    layout: "VerticalLayout",
  },
  {
    path: "/crm/leads",
    component: lazy(() => import("../../view/leads/leadsList")),
    layout: "VerticalLayout",
  },
  {
    path: "/newleads",
    component: lazy(() => import("../../view/leads/leadAddAndUpdate")),
    layout: "VerticalLayout",
  },
  {
    path: "/reports/reportsList",
    component: lazy(() => import("../../view/Reports/reportsList")),
    layout: "VerticalLayout",
  },
  {
    path: "/reports/dynamic-reports",
    component: lazy(() => import("../../view/Reports/dynamicReports/index")),
    layout: "VerticalLayout",
  },
  {
    path: "/reports/dynamicreports",
    component: lazy(() => import("../../view/Reports/dynamicReports/reportTable")),
    layout: "VerticalLayout",
  },
  {
    path: "/allsettings",
    component: lazy(() => import("../../view/Settings/AllSettings")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/leads/source",
    component: lazy(() => import("../../view/Settings/Leads/Source")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/leads/qualification",
    component: lazy(() => import("../../view/Settings/Leads/Qualification")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/leads/industry",
    component: lazy(() => import("../../view/Settings/Leads/Industry")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/leads/brand",
    component: lazy(() => import("../../view/Settings/Leads/Brand")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/enquiry/enquirytype",
    component: lazy(() => import("../../view/Settings/Enquiry/Enquirytype")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/authorization",
    component: lazy(() => import("../../view/Settings/Authorization")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/approval/approvalprocess",
    component: lazy(() => import("../../view/Settings/Approval/approvalprocess")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/approval/approvalsteps",
    component: lazy(() => import("../../view/Settings/Approval/approvalprocess")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/approval/approvalsteps",
    component: lazy(() => import("../../view/Settings/Approval/approvalprocess")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/user/adduser",
    component: lazy(() => import("../../view/Settings/Approval/approvalprocess")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/user/allusers",
    component: lazy(() => import("../../view/Settings/Approval/approvalprocess")),
    layout: "VerticalLayout",
  },
  {
    path: "/MyProfile",
    component: lazy(() => import("../../view/Settings/Profile")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/usermaster/adduser",
    component: lazy(() => import("../../view/Settings/UserMaster/AddUser")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/usermaster/allusers",
    component: lazy(() => import("../../view/Settings/UserMaster/AllUsers")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/usermaster/addusers",
    component: lazy(() => import("../../view/Settings/UserMaster/AddUser")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/enquiry/settings",
    component: lazy(() => import("../../view/Settings/Enquiry/Settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/general/notification",
    component: lazy(() => import("../../view/Settings/General/notification")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/enquiry",
    component: lazy(() => import("../../view/Settings/Enquiry")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/leads",
    component: lazy(() => import("../../view/Settings/Leads")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/general",
    component: lazy(() => import("../../view/Settings/General")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/terms",
    component: lazy(() => import("../../view/Settings/General/terms")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/leadsettings",
    component: lazy(() => import("../../view/Settings/Leads/Settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/tasks",
    component: lazy(() => import("../../view/Settings/Tasks")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/flexiquote",
    component: lazy(() => import("../../view/Settings/FlexiQuote")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/flexiquote/status",
    component: lazy(() => import("../../view/Settings/FlexiQuote/Status")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/customercomplaints",
    component: lazy(() => import("../../view/Settings/CustomerComplaints")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings/prodCategory",
    component: lazy(() => import("../../view/Settings/General/ProductCategory")),
    layout: "VerticalLayout",
  },
  {
    path: "/newcustomercomplaints",
    component: lazy(() => import("../../view/CustomerComplaints/newCustomerComplaints")),
    layout: "VerticalLayout",
  },
  {
    path: "/customercomplaints",
    component: lazy(() => import("../../view/CustomerComplaints/complaintsList")),
    layout: "VerticalLayout",
  },
  {
    path: "/bpmasterlist",
    component: lazy(() => import("../../view/BPMaster/BPMasterList")),
    layout: "VerticalLayout",
  },
  {
    path: "/bpmastercreate",
    component: lazy(() => import("../../view/BPMaster/BPMasterCreateorupdate")),
    layout: "VerticalLayout",
  },
  {
    path: "/task",
    component: lazy(() => import("../../view/Task/TaskList")),
    layout: "VerticalLayout",
  },
  {
    path: "/resetpassword",
    component: lazy(() => import("../../view/Login/Password/ResetPassword")),
    layout: "FullLayout",
  },
];

export default PagesRoutes;
